<template>
  <div class="box">
    <div class="top">
      <div class="top_inner">
        <div class="img_box">
          <img class="img_inner" :src="myImage || require('@/assets/images/Headportrait@2x.png')" alt="">
        </div>
        <button class="online" type="button">{{ JishiStatus || '' }}</button>
      </div>
    </div>

    <div class="main">
      <div class="today_look">今日概览</div>

      <div class="overview_row">
        <div class="circle_box">
          <div>
            <span class="yellow_num">{{ nowClockData.clocktotalcount || 0 }}</span>
            <span class="circle_unit">次</span>
          </div>
          <div class="circle_label">做钟次数</div>
        </div>

        <div class="clock_box" @click="toClockDetail">
          <div v-for="(item, index) in clockList" :key="item.clocktype" class="clock_item" :class="'doit' + index">
            {{ item.clocktype }} {{ item.count || 0 }}
          </div>
        </div>
        <div class="arrow" @click="toClockDetail">›</div>
      </div>

      <div class="overview_row">
        <div class="circle_box">
          <div>
            <span class="money_symbol">￥</span>
            <span class="blue_num">{{ ((nowAData.persume_total && nowAData.persume_total.totalpersume) || 0) | toMoney
              }}</span>
          </div>
          <div class="circle_label">提成金额</div>
        </div>

        <div class="clock_box commission_box" @click="toCommisionDetail">
          <div class="get_box">
            <div class="commission_title">做钟提成</div>
            <div class="commission_money">￥ {{ ((nowAData.persume_clock_total &&
              (nowAData.persume_clock_total.basepersume || nowAData.persume_clock_total.steppersume)) || 0) | toMoney }}
            </div>
          </div>
          <div class="get_box">
            <div class="commission_title">商品提成</div>
            <div class="commission_money">￥ {{ ((nowAData.persume_goods_total &&
              nowAData.persume_goods_total.salepersume) || 0) | toMoney }}</div>
          </div>
          <div class="get_box">
            <div class="commission_title">售卡提成</div>
            <div class="commission_money">￥ {{ ((nowAData.persume_card_total && (nowAData.persume_card_total.basepersume
              || nowAData.persume_card_total.steppersume)) || 0) | toMoney }}</div>
          </div>
        </div>
        <div class="arrow" @click="toCommisionDetail">›</div>
      </div>
    </div>

    <div v-if="!isDisableJishiPersumeInfo" class="persume_info">
      <div class="split_line"></div>

      <div class="tabs">
        <div v-for="(tab, index) in ['全部', '今天', '昨天', '本月', '上月']" :key="tab" class="tab_item"
          :class="{ active: active === index || (active === '' && index === 0) }" @click="timeChange(index)">
          {{ tab }}
        </div>
      </div>

      <div class="bottom">
        <div class="item" @click="toClockDetail">
          <div class="card_title">做钟次数</div>
          <div class="card_num">
            <span ref="bottomCountRef">{{ ((aData.persume_clock_total && aData.persume_clock_total.count) || 0)
              }}</span>
            <em>次</em>
          </div>
        </div>

        <div class="item item2" @click="toCommisionDetail">
          <div class="card_title">提成金额</div>
          <div class="card_num">
            <span ref="bottomTotalpersumeRef">{{ ((aData.persume_clock_total && aData.persume_clock_total.basepersume)
              || 0) }}</span>
          </div>
        </div>

        <div class="arrow bottom_arrow" @click="toAll">›</div>
      </div>
    </div>

    <div class="logo_bottom">
      <img src="@/assets/order/bottom-logo@2x.png" alt="">
    </div>
  </div>
</template>

<script>
import { getPersumestatistics, getClockstatistics, getJishicode, jishiDuty, postParameterSetting, getUserInfo } from "@/api/Jishi";
import { handleSessionStorage } from "@/utils";
import { mapState } from "vuex";
export default {
  name: "JiShiReportHome",
  props: {},
  data() {
    return {
      isDisableJishiPersumeInfo: false,
      isSelected: "",
      active: "",
      aData: {},
      clockData: {},
      subscribeData: {},
      nowAData: {},
      nowClockData: {},
      nowSubscribeData: {},
      clockList: [
        { clocktype: "排钟", count: 0 },
        { clocktype: "点钟", count: 0 },
        { clocktype: "选钟", count: 0 },
        { clocktype: "加钟", count: 0 },
        { clocktype: "退钟", count: 0 },
        { clocktype: "旷钟", count: 0 }
      ],
      originParams: {},
      startTime: "",
      endTime: "",
      userInfo: {},
      myImage: "",
      isLock: false,
      JishiStatus: '',
      JishiCodes: '',
      getVpnId: ""
    };
  },
  computed: {},
  components: {},
  created() {
    const preStoreInfo = localStorage.getItem("store");
    if (preStoreInfo) {
      this.getVpnId = JSON.parse(preStoreInfo).vpnId;
      this.isDisableJishiPersumeInfo = JSON.parse(preStoreInfo).vpnInfo.DisableJishiViewPersume
      // console.log("preStoreInfo ==== "  +JSON.stringify(JSON.parse(preStoreInfo)))
    }
    this.jishicode()
  },
  mounted() {

  },
  methods: {
    duty() {
      const params = {
        JiShiCode: this.JishiCodes,
        DutyType: this.JishiStatus,
        VpnId: this.getVpnId
      }
      jishiDuty(params).then(res => {
        console.log(res, '上下班打卡')
        this.$vux.toast.show({
          text: "操作成功",
          type: "success"
        });
      })
    },
    async jishicode() {
      const params = {
        VpnId: this.getVpnId
      }
      getJishicode(params).then(res => {
        console.log('666上下班返回值 =-====. ' + JSON.stringify(res))
        const JishiCode = res.EmployCode || ""
        const AccountType = res.AccountType || 0
        this.JishiStatus = res.EmployName || "";
        this.JishiCodes = JishiCode;
        if (JishiCode) {
          handleSessionStorage.set("jsCode", JishiCode);
          this.timeChange(0);
          this.queryToday();
          this.getSetting()
        } else {
          return this.$vux.toast.text("技师编号为空", "middle");
        }

      })
    },

    queryToday() {
      const date = new Date();
      const today = this.formatDate(date);
      const tomorrow = this.formatDate(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1));
      const originParams = {
        Pager: {
          PageIndex: 0,
          PageSize: 1000,
        },
        JiShiCode: handleSessionStorage.get('jsCode'), // 技师或服务员编号
        StartTime: today,
        EndTime: tomorrow,
        ClockType: '',
        VpnId: this.getVpnId
      }
      getPersumestatistics(originParams).then(res => {
        this.nowClockData = res;
        console.log("nowClockData ===== " + JSON.stringify(res))
        if (this.nowClockData && this.nowClockData.lst_persume_clock !== undefined) {
          this.clockList = this.clockList.map((v) => {
            this.nowClockData.lst_persume_clock.forEach(val => {
              if (v.clocktype === val.clocktype) {
                v.count = v.count + val.numbercount;
              }
            });
            return v;
          });
        }
      }).catch(error => {

      })
    },

    getSetting() {

      console.log("this.isDisableJishiPersumeInfo ===== " + this.isDisableJishiPersumeInfo)
      if (!this.isDisableJishiPersumeInfo) {
        this.queryTodayForSetting();
      }
    },

    queryTodayForSetting() {
      const date = new Date();
      const today = this.formatDate(date);
      const tomorrow = this.formatDate(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1));

      const originParams = {
        Pager: {
          PageIndex: 0,
          PageSize: 1000,
        },
        JiShiCode: handleSessionStorage.get('jsCode'), // 技师或服务员编号
        StartTime: today,
        EndTime: tomorrow,
        ClockType: '',
        VpnId: this.getVpnId
      }
      getPersumestatistics(originParams).then(res => {
        this.nowAData = res;
      }).finally(onfinally => {

        console.log("getPersumestatistics ==== ")
      })
    },

    queryUserInfo() {
      getUserInfo().then(res => {
        this.userInfo = res;
        if (res.PhotoImg) {
          this.myImage = "data:image/png;base64," + res.PhotoImg;
        } else if (res.PhotoWechatUrl) {
          this.myImage = res.PhotoWechatUrl;
        } else {
          // this.myImage = require("../../../static/image/Headportrait@2x.png");
        }
      }).finally(onfinally => {
        console.log("queryUserInfo ==== ")
      })
    },
    toAll() {
      this.$router.push("/JiShiCommissionAndClockDetail");
    },
    toClockDetail() {
      this.$router.push("/JiShiClockDetail");
    },
    toCommisionDetail() {
      if (this.isDisableJishiPersumeInfo) {
        return
      }
      this.$router.push("/JiShiCommissionDetail");
    },

    async timeChange(index) {
      this.active = index
      console.log("时间改变事件 ====" + handleSessionStorage.get("jsCode"));
      if (!handleSessionStorage.get("jsCode")) {
        return;
      }
      const timeRange = this.getTimeRangeByTab(index);
      this.startTime = timeRange.startTime;
      this.endTime = timeRange.endTime;
      const originParams = {
        Pager: {
          PageIndex: 0,
          PageSize: 1000,
        },
        JiShiCode: handleSessionStorage.get('jsCode'), // 技师或服务员编号
        StartTime: this.startTime,
        EndTime: this.endTime,
        ClockType: '',
        VpnId: this.getVpnId
      }
      getPersumestatistics(originParams).then(res => {
        this.aData = res;
      }).finally(onfinally => {
        console.log("timeChangetimeChange ==== ")
      })
    },

    queryCurrentDay() {
      return this.formatDate(new Date());
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    getTimeRangeByTab(index) {
      const date = new Date();
      const today = this.formatDate(date);
      const tomorrow = this.formatDate(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1));

      if (index === 0) {
        return {
          startTime: "",
          endTime: tomorrow
        };
      }

      if (index === 1) {
        return {
          startTime: today,
          endTime: tomorrow
        };
      }

      if (index === 2) {
        const yesterdayDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
        const yesterday = this.formatDate(yesterdayDate);
        return {
          startTime: yesterday,
          endTime: tomorrow
        };
      }

      if (index === 3) {
        const monthStart = this.formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
        return {
          startTime: monthStart,
          endTime: tomorrow
        };
      }

      if (index === 4) {
        const lastMonthStartDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        const lastMonthEndDate = new Date(date.getFullYear(), date.getMonth(), 0);
        return {
          startTime: this.formatDate(lastMonthStartDate),
          endTime: this.formatDate(lastMonthEndDate)
        };
      }

      return {
        startTime: "",
        endTime: tomorrow
      };
    }
  }
};
</script>
<style scoped lang="scss">
.box {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  color: #333333;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  overflow-x: hidden;
}

.top {
  height: 184px;
  background: #add9e5;
  padding: 48px 0 0 44px;
  box-sizing: border-box;
}

.top_inner {
  display: flex;
  align-items: center;
}

.img_box {
  width: 82px;
  height: 82px;
  margin-right: 60px;
  box-sizing: border-box;
  border-radius: 50%;
  background: #e8e8e8;
  overflow: hidden;

  .img_inner {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.online {
  width: 94px;
  height: 46px;
  border: 0px solid #a7ce9f;
  border-radius: 4px;
  background: #d5e7ee;
  color: #222222;
  font-size: 24px;
  line-height: 42px;
  text-align: center;
  padding: 0;
  outline: none;
}

.main {
  position: relative;
  z-index: 1;
  margin-top: -30px;
  padding: 30px 24px 44px;
  background: #ffffff;
  border-radius: 24px 24px 0 0;
  box-sizing: border-box;
}

.today_look {
  margin-bottom: 36px;
  font-size: 28px;
  line-height: 40px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
}

.overview_row {
  display: flex;
  align-items: center;
  margin-bottom: 34px;

  &:last-child {
    margin-bottom: 0;
  }
}

.circle_box {
  flex: 0 0 122px;
  width: 122px;
  height: 122px;
  margin: 0 20px 0 34px;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 24px 0 rgba(221, 221, 221, 0.56);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.yellow_num {
  font-size: 26px;
  line-height: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #ffb600;
}

.blue_num,
.money_symbol {
  font-size: 22px;
  line-height: 34px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #25a4ff;
}

.circle_unit {
  margin-left: 8px;
  font-size: 22px;
  color: #333333;
}

.circle_label {
  margin-top: 10px;
  font-size: 22px;
  line-height: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
}

.clock_box {
  flex: 1;
  min-width: 0;
  min-height: 122px;
  padding: 20px 16px;
  background: #f6f6f6;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
}

.clock_item {
  width: 33.333%;
  margin: 5px 0;
  padding-left: 26px;
  position: relative;
  box-sizing: border-box;
  font-size: 22px;
  line-height: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
  white-space: nowrap;

  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 11px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
  }
}

.commission_box {
  justify-content: space-around;
  padding: 18px 14px;
}

.get_box {
  width: 33.333%;
  text-align: center;
  box-sizing: border-box;
}

.commission_title {
  margin-bottom: 26px;
  font-size: 21px;
  line-height: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #333333;
  white-space: nowrap;
}

.commission_money {
  font-size: 21px;
  line-height: 30px;
  color: #333333;
  white-space: nowrap;
}

.arrow {
  flex: 0 0 48px;
  width: 48px;
  color: #59cfff;
  font-size: 56px;
  line-height: 1;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
}

.split_line {
  height: 32px;
  background: #eeeeee;
}

.tabs {
  display: flex;
  height: 70px;
  background: #ffffff;
  border-bottom: 1px solid #e7e7e7;
}

.tab_item {
  position: relative;
  flex: 1;
  height: 70px;
  font-size: 24px;
  line-height: 70px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  text-align: center;
  color: #333333;
  box-sizing: border-box;

  &:not(:last-child) {
    border-right: 1px solid #f1f1f1;
  }

  &.active {
    color: #18c4c8;

    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -1px;
      width: 100%;
      height: 2px;
      background: #18c4c8;
    }
  }
}

.bottom {
  display: flex;
  align-items: center;
  padding: 34px 30px 0;
  box-sizing: border-box;
}

.item {
  width: 140px;
  height: 138px;
  padding-top: 22px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #4bb7ba 0%, #5fc4c9 100%);
  box-shadow: 0 5px 12px 0 rgba(157, 157, 157, 0.5);
  border-radius: 6px;
  color: #ffffff;
  text-align: center;
}

.item2 {
  flex: 1;
  min-width: 0;
  margin-left: 16px;
  background: linear-gradient(180deg, #6564ff 0%, #7777ff 100%);
}

.card_title {
  margin-bottom: 20px;
  font-size: 22px;
  line-height: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
}

.card_num {
  font-size: 38px;
  line-height: 46px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;

  em {
    margin-left: 18px;
    font-style: normal;
    font-size: 24px;
    vertical-align: 5px;
  }
}

.bottom_arrow {
  flex-basis: 38px;
  width: 38px;
  margin-left: 4px;
}

.logo_bottom {
  margin-top: auto;
  padding-top: 226px;
  padding-bottom: 22px;
  text-align: center;
  opacity: 0.55;

  img {
    width: 192px;
  }
}

.doit0 {
  &:after {
    background: #1890ff;
  }
}

.doit1 {
  &:after {
    background: #ff9570;
  }
}

.doit2 {
  &:after {
    background: #ffc53d;
  }
}

.doit3 {
  &:after {
    background: #52c41a;
  }
}

.doit4 {
  &:after {
    background: #780650;
  }
}

.doit5 {
  &:after {
    background: #f5222d;
  }
}
</style>
